import React, {Fragment} from "react";
import {ToolTipContainer} from "./CorrectionManager";
import Faq from "./FAQModal/Faq";
import { FAQ_TYPES } from "./constants";
import getArmScore from "../Reports/util/getArmScore";
import { isEarlyReader } from "../../services/EarlyReaderService";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { assignmentTypes } from "../../constants/constants";


function CorrectionSidebar(props) {
  const {activity, history} = props;

  const {t} = useTranslation("review_activity")

  const statusCardStyle = {}
  let hasPhraseCorrectionErrors = props.phraseCorrectionErrors.filter(x => x).length > 0;
  if (props.modified && !hasPhraseCorrectionErrors) statusCardStyle.border = '3px solid red'

  return (
    <div className="correction-sidebar">
      <div className="card status" style={statusCardStyle}>
        {renderStatusContents()}
      </div>
      {renderStats()}
      {renderFAQ()}
    </div>
  );

  function renderStatusContents() {
    let hasPhraseCorrectionErrors = props.phraseCorrectionErrors.filter(x => x).length > 0;
    if (props.modified && !hasPhraseCorrectionErrors) return <SaveButton saveAssessment={props.saveAssessment} />

    // accumulate reassess points to determine if reassessment is recommended
    let reassessPoints = 0;
    props.faqs.forEach((faq) => {
      switch (faq) {
        case FAQ_TYPES.UNDER_REVIEW:
          reassessPoints += 3;
          break
        case FAQ_TYPES.REASSESS:
          reassessPoints += 5;
          break
        case FAQ_TYPES.UNSCORABLE_TEST:
          reassessPoints += 1;
          break
        case FAQ_TYPES.EARLY_NEXT_BUTTON:
          reassessPoints += 4;
          break
        case FAQ_TYPES.NOT_TRYING:
          reassessPoints += 4;
          break
        case FAQ_TYPES.MINIMUM_SCORING:
          reassessPoints += 1;
          break
        case FAQ_TYPES.LOOKS_WRONG:
          reassessPoints += 1;
          break
        case FAQ_TYPES.YELLOW_FLAG:
          reassessPoints += 3;
          break
        case FAQ_TYPES.YELLOW_FLAG_PRACTICE:
          reassessPoints += 0;
          break
        case FAQ_TYPES.INCONSISTENT_TIME:
          reassessPoints += 2;
          break
        default:
          reassessPoints += 0;
      }
    })

    const needsReassessment = reassessPoints > 6;
    return (
      <Fragment>
        <div className="card-title">{t("Status")}</div>
        <div className="card-body primary-status">{t(props.status.primary)}</div>
        {props.status.secondary && (<div className="card-body secondary-status">{props.status.secondary}</div>)}
        {props.isAssessment && needsReassessment && (
            <>
            <div className="cardReassess">Consider reassessing this student.</div>
            <div className="reassessDescriptor">There are some signs and signals that reassessing this student might produce meaningfully different results.</div>
        </>
        )}
      </Fragment>
    )
  }

  function renderStats() {
    const { accuracyScore, wcpmScore } = props;
    let formattedAccuracy = typeof accuracyScore === "number" ? `${accuracyScore}%` : "--";
    let adj_wcpm = typeof wcpmScore === "number" ? Math.round(wcpmScore) : wcpmScore;
    let readTime = getReadTime(props.readTime);
    let showSecondToolTip = !props.isNonEdmActivity;

    let locale = 'EN-US';
    if (activity?.story?.tags?.includes('ES-MX')) locale = 'ES-MX';
    let armScore = getArmScore(activity.studentId, activity, locale);
    if (locale !== 'ES-MX' && activity.type !== "assessment") armScore = activity?.scoreEstimates?.ARM_estimate;
    if (locale === 'ES-MX' && isEarlyReader(activity)) armScore = null;
    if (armScore) armScore = armScore.toFixed(2);
    else armScore = "--";
    // hide the score and Adjusted WCPM for the letterNamingAndSounds type
    if (activity.type === assignmentTypes.LETTER_NAMING_AND_SOUNDS) {
      armScore = null;
      showSecondToolTip = false;
    }


    if(['PRE-READER', 'UNDER_REVIEW'].includes(props.status.id)){
      adj_wcpm = "--";
      readTime = "--";
      formattedAccuracy = "--";
    }
    return (
      <div className="card">
        <ToolTipContainer type="accuracy">
          <div className="stats-row">
            <div>{t("Accuracy")}</div>
            <div>{formattedAccuracy}</div>
          </div>
        </ToolTipContainer>
        {showSecondToolTip ? (
            <ToolTipContainer type="adj_wcpm">
                <div className="stats-row">
                    <div>{t("Adjusted WCPM")}</div>
                    <div>{adj_wcpm}</div>
                </div>
            </ToolTipContainer>
        ) : null}
        <div className="stats-row">
          <div>{t("Adjusted Read Time")}</div>
          <div>{readTime}</div>
        </div>
        {armScore && <div className="stats-row">
          <div>{t("common:arm_score")}</div>
          <div>{armScore}</div>
        </div>}
      </div>
    );
  }
  
  function getReadTime(readTime) {
    if(!readTime) return "--";
    let seconds = Math.round(readTime / 1000);
    const minutes = Math.floor(seconds / 60);
    seconds %= 60;
    seconds = seconds.toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  }

  function renderFAQ() {
    const {faqs} = props;
    const sliced = faqs.slice(0, 3);

    return (
      <div className="card">
        <div className="card-title faq">{t("Questions?")}</div>
        {sliced.map(id => <Faq key={id} id={id} setSelectedFaq={props.setSelectedFaq} highPriority={id !== 'default'}/>)}
      </div>
    );
  }
}

function SaveButton(props) {
  const {t} = useTranslation("review_activity");
  return (
    <div className="save-correction-container">
      <button className='primaryTeacherButton' onClick={props.saveAssessment}>
        {t("SAVE CHANGES")}
      </button>
    </div>
  );
}

export default withRouter(CorrectionSidebar);